// extracted by mini-css-extract-plugin
export default {"ButtonGroup":"CustomButtonGroup_ButtonGroup__OMvGi"};